import { useEffect } from "react";

type DocumentMeta = {
  title: string;
  description: string;
  canonicalPath: string;
};

function ensureMetaTag(name: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.name = name;
    document.head.append(element);
  }

  return element;
}

function ensureCanonicalLink() {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.append(element);
  }

  return element;
}

export function useDocumentMeta({ title, description, canonicalPath }: DocumentMeta) {
  useEffect(() => {
    document.title = title;
    ensureMetaTag("description").content = description;
    ensureCanonicalLink().href = new URL(canonicalPath, window.location.origin).toString();
  }, [canonicalPath, description, title]);
}
